import {form, ff} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {LinkContainer} from "react-router-bootstrap";
import {Button, CardBody, CardHeader, Col, Container, Row, Card} from "reactstrap";
import CgoApi from "../api/gen/cgo/CgoApi";

import './PasswordResetPage.scss'
import {reduxForm} from "redux-form";
import {withTranslation, WithTranslation} from "react-i18next";

function NewPassword(props) {
    const {handleSubmit, error, submitting, t} = props;
    return <form.Form horiznotal onSubmit={handleSubmit}>
        <form.FormBody>
            <Card>
                <CardHeader>{t('password_reset')}</CardHeader>
                <CardBody>
                    {error && <span className={"text-red"}>{error}</span>}
                    <ff.String label={t('password')} name={"newPassword"} type={"password"} required />
                    <ff.String label={t('password_again')} name={"newPassword_repeat"} type={"password"} required />
                </CardBody>
            </Card>
        </form.FormBody>
        <form.FormActions submitButton={t('send')} submitting={submitting} />
    </form.Form>
}

NewPassword.validate = (data, props) => {
    const {t} = props;
    const errors = {};
    if (!data.newPassword) {
        errors.newPassword = t('validation.password_required');
    }
    if (!data.newPassword_repeat) {
        errors.newPassword_repeat = t('validation.password_again_required');
    }

    if (data.newPassword && data.newPassword_repeat && data.newPassword !== data.newPassword_repeat) {
        errors._error = t('validation.passwords_not_matching')
    }
    return errors;
};

const NewPasswordForm = reduxForm({form: "newPassword", validate: NewPassword.validate})(NewPassword);

class PasswordResetPage extends Component<WithTranslation> {

    state = {
        done: false
    };

    render() {
        const {done} = this.state;
        const {t} = this.props;
        const urlParams = new URLSearchParams(this.props.location.search);
        const code = urlParams.get("code");

        return <div className="password-reset">
            <Container>
                <Row className="justify-content-center pt-5">
                    <Col xs="12" sm={{size: 4, offset:4}} md={{size: "auto", offset: 0}} className={"inverse"}>
                        {!code && <Card>
                            <CardHeader>{t('password_reset')}</CardHeader>
                            <CardBody>
                                {t('no_password_reset_code_found')}
                            </CardBody>
                        </Card>}
                        {code && !done && <NewPasswordForm
                            onSubmit={({newPassword}) => CgoApi.resetPassword({newPassword, code})}
                            onSubmitSuccess={() => this.setState({done: true})}
                        />}
                        {done && <div>
                            <Card>
                                <CardHeader>{t('password_reset')}</CardHeader>
                                <CardBody>
                                    {t('password_changed_log_in')}
                                </CardBody>
                            </Card>
                            <LinkContainer to={"/login"} ><Button color={"primary"}>{t('pages.login.title')}</Button></LinkContainer>
                        </div>}
                    </Col>
                </Row>
            </Container>
        </div>;
    }
}


export default (withTranslation()(PasswordResetPage));

